import NumFormat from './NumFormat.vue'

NumFormat.install = (Vue) => {
    Vue.component(NumFormat.name, NumFormat)
}

export default NumFormat
